import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DeletePopupComponent } from '../common/delete-popup/delete-popup.component';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { StorageService } from '../../services/common/storage.service';
import { Router } from '@angular/router';
import { CommonService } from '../../services/common/common.service';
import { ApiService } from '../../services/api.service';
import { ApiUrlHelper } from '../../services/api-url-helper/api-url-helper';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import { VerifyOtpMessageDialogueComponent } from '../verify-otp-message-dialogue/verify-otp-message-dialogue.component';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../../services/languageService/language-service.service';

@Component({
  selector: 'app-verify-otp',
  templateUrl: './verify-otp.component.html',
  styleUrl: './verify-otp.component.scss',
})
export class VerifyOtpComponent {
  config = {
    allowNumbersOnly: true,
    length: 6,
    isPasswordInput: false,
    disableAutoFocus: false,
    placeholder: '',
  };
  verifyOtpForm: FormGroup;
  otp: any;
  email: string = '';
  remainagAttemps: number = 0;
  maskedEmail: string = '';
  userTypeIdForImage: any
  constructor(
    public dialog: MatDialog,
    private storageService: StorageService,
    private formBuilder: FormBuilder,
    private router: Router,
    private commonService: CommonService,
    private apiService: ApiService,
    private apiUrl: ApiUrlHelper,
    private toaster: ToastrService,
    private spinner: NgxSpinnerService,
    private translate: TranslateService,
    private languageService: LanguageService,
  ) {
    this.verifyOtpForm = this.formBuilder.group({ otp: ['', [Validators.required]], });
  }
  ngOnInit(): void {
    this.languageService.language$.subscribe(language => {
      this.translate.use(language);
    });
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    this.GetUserTypeIdForShowImage();
    history.pushState(null, '', location.href);

    window.addEventListener('popstate', () => {
      window.location.href = '/login'; // Forces reload and redirects
    });

    // this.remainagAttemps = this.storageService.getValue('RemaingCount') ?? 0;
    this.email = this.storageService.getValue('email');
    if (!this.email) {
      this.router.navigate(['/signup'])
      return
    } else {
      this.getDataByEmail()
    }
    this.maskedEmail = this.maskEmail(this.storageService.getValue('email'));
  }


  GetUserTypeIdForShowImage() {
    let UserTypeId = this.storageService.getValue('userTypeId');
    this.userTypeIdForImage = Number(UserTypeId);
  }

  getDataByEmail() {
    const apiurl = this.apiUrl.apiUrl.signUp.getOTPDataByEmail + `?Email=${this.email}`;

    this.apiService.doGet(apiurl).subscribe((data) => {
      if (data && data.Data) {
        this.remainagAttemps = data.Data.RemainingCount
      }
    })

  }
  // openDialog(event: Event) {
  //   // event.stopPropagation();
  //   event.preventDefault();
  //   this.dialog.open(DeletePopupComponent, {
  //     width: '600px',
  //     height: '365px',
  //     data: 'abhishek',
  //   });
  // }
  onOtpChange(event: any) {
    this.otp = event;
  }

  onVerifyOtp(event: any) {
    if (!this.email) {
      this.router.navigate(['/signup'])
      return
    }
    const FormData = {
      otp: this.verifyOtpForm.controls['otp'].value.trim(),
      email: this.email,
    };
    this.spinner.show();
    const apiUrl = this.apiUrl.apiUrl.signUp.verifyOtp;
    this.apiService
      .doPost(apiUrl, FormData)
      .pipe()
      .subscribe({
        next: (response) => {
          this.spinner.hide();
          if (response && response.Success) {
            //this.toaster.success(response.Message);
            this.remainagAttemps = response.Data.RemainingCount;
            this.storageService.setValue(
              'RemaingCount',
              response.Data.RemainingCount
            );
            let Email = encodeURIComponent(this.commonService.Encrypt(this.email));
            let UserType = encodeURIComponent(this.commonService.Encrypt(this.storageService.getValue('userTypeId')));
            // let utcTime = encodeURIComponent(this.commonService.Encrypt(new Date().toUTCString()))
            let utcTime = encodeURIComponent(this.commonService.Encrypt(new Date().toUTCString() + 1))

            const dialogRef = this.dialog.open(VerifyOtpMessageDialogueComponent, {
              width: '700px',
              data: {
                // data will be based on API response
                fontIcon: 'check_circle_outlined',
                title: 'EMAIL_VERIFIED',
                Description: 'EMAIL_VERIFIED_DESC'
              }
            })

            dialogRef.afterClosed().subscribe((result: any) => {
              // if (result) {
              this.router.navigate(['/signup-questions'], {
                queryParams: { email: Email, usertype: UserType, expiry: utcTime },
              });
              // }
            });

          } else {
            //this.toaster.error(response.Message);
            this.remainagAttemps = response.Data.RemainingCount;
            this.storageService.setValue(
              'RemaingCount',
              response.Data.RemainingCount
            );
            if (response.Data.IsLimitExhausted || +response.Data.RemainingCount >= 4) {
              const dialogRef = this.dialog.open(VerifyOtpMessageDialogueComponent, {
                width: '700px',
                data: {
                  // data will be based on API response
                  fontIcon: 'report_gmailerrorred',
                  title: 'ATTEMPT_LIMIT_EXHAUSTED',
                  Description: 'ATTEMPT_LIMIT_EXHAUSTED_DESC'
                }
              })

              dialogRef.afterClosed().subscribe(() => {
                this.verifyOtpForm.get('otp').setValue('');
                this.router.navigate(['/landing-page']);
              });
            }
            else if (!response.Data.IsSuccess) {
              const dialogRef = this.dialog.open(VerifyOtpMessageDialogueComponent, {
                width: '700px',
                data: {
                  // data will be based on API response
                  fontIcon: 'error_outlined',
                  title: 'EMAIL_VERIFICATION_FAILED',
                  Description: 'EMAIL_VERIFICATION_FAILED_DESC'
                }
              })

              dialogRef.afterClosed().subscribe((result: any) => {
                if (result) {
                  this.verifyOtpForm.get('otp').setValue('');
                }
              });
            }
          }
        },
        error: (er) => {
          this.spinner.hide();
          console.error(er);
          this.toaster.error(er.Message);
        },
      });
  }
  maskEmail(email: string): string {
    let parts = email.split('@');
    if (parts.length === 2) {
      let maskedLocal = parts[0].substring(0, 5) + '...'; // Show first 5 chars
      return maskedLocal + '@' + parts[1]; // Keep domain visible
    }
    return email; // Return original if not valid
  }
  resendCode() {
    this.email = this.storageService.getValue('email');
    this.spinner.show();
    const apiUrl = this.apiUrl.apiUrl.signUp.resendOTP.replace(
      '{Email}',
      encodeURIComponent(this.email)
    );
    this.apiService
      .doGet(apiUrl)
      .pipe()
      .subscribe({
        next: (response) => {
          this.spinner.hide();
          if (response && response.Success) {
            this.toaster.success(this.translate.instant(response.Message));
            this.maskedEmail = this.maskEmail(this.storageService.getValue('email'));
          } else {
            this.toaster.error(this.translate.instant(response.Message));
            this.maskedEmail = this.maskEmail(this.storageService.getValue('email'));
          }
        },
        error: (er) => {
          this.spinner.hide();
          console.error(er);
          this.toaster.error(er.Message);
        },
      });
  }
  onSignup() {
    this.router.navigate(['/signup']);
  }

  getBackgroundClass() {
    let baseClass = 'image-height';
    switch (this.userTypeIdForImage) {
      case 2:
        return `${baseClass} recoverimage-height`;
      case 3:
        return `${baseClass} firmverifyotp-height`;
      default:
        return `${baseClass} recoverimage-height`;
    }
  }
}
